import React from "react";
import ComponentHeading from "../../../common/componentHeading/ComponentHeading";
import { apiAutomationWhyChooseUsCardData } from "../../../helper/cardsData/apiAutomationMockData";
import WhyChooseUsCard from "../../../common/whyChooseUsCard/WhyChooseUsCard";

const ApiAutomationWhyChooseUs = () => {
  return (
    <div className="bg-primaryColor/10">
      <div className="component-padding mx-auto max-w-screen-2xl">
        <ComponentHeading heading="Why Choose Us?" />
        <div className="mt-8 grid gap-8 lg:mt-12 lg:grid-cols-2 lg:gap-12">
          {apiAutomationWhyChooseUsCardData.map((cardData) => {
            return (
              <React.Fragment key={cardData.heading}>
                <WhyChooseUsCard
                  heading={cardData.heading}
                  icon={cardData.icon}
                  description={cardData.description}
                />
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ApiAutomationWhyChooseUs;
